export default "__VITE_PUBLIC_ASSET__25c35557__"